module.exports = __webpack_public_path__ + "img/phone_black.f5c271bc.svg";